<ng-select [items]="displayList" bindLabel="type" bindValue="id" [virtualScroll]="true"
    placeholder="{{_placeholder}}" [(ngModel)]="id" (ngModelChange)="onChanged()" [selectOnTab]="true" class="no-border">
</ng-select>
